import React from "react";
import { SensorDataSession, Station } from "@shared/models";

import { SensorDataSessionStationsItem } from "./components";

import "./index.scss";

interface SensorDataSessionStationsListProps {
  stations: Partial<Station>[];
  session?: SensorDataSession | null;
  onDownload: () => void;
}

const SensorDataSessionStationsList = (props: SensorDataSessionStationsListProps) => {
  const { stations, session, onDownload } = props;
  return (
    <div className="sensor-data-session-stations">
      {stations.map((station) => (
        <SensorDataSessionStationsItem
          key={station.station_code}
          station={station}
          session={session}
          onDownload={onDownload}
        />
      ))}
    </div>
  );
};

export default SensorDataSessionStationsList;
